<template>
<div class="app-container">
  <HeaderComponent v-if="$route.name && $route.name !== 'login' && $route.name !== 'answerQuestions'&& $route.name !== 'complete'&& $route.name !== 'wrongAnswer'&& $route.name !== 'register'"  />
  <a-config-provider :locale="zhCN">
    <router-view/>
  </a-config-provider>
  <FooterComponent v-if="$route.name && $route.name !== 'login' && $route.name !== 'answerQuestions'&& $route.name !== 'complete'&& $route.name !== 'wrongAnswer'&& $route.name !== 'register'" />
  <FloatMenu v-if="$route.name && $route.name !== 'login' && $route.name !== 'answerQuestions'&& $route.name !== 'complete'&& $route.name !== 'wrongAnswer'&& $route.name !== 'register'" />
</div>
</template>

<script>
import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';
import FloatMenu from './components/FloatMenu.vue';

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('en')
export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    FloatMenu
  },
  data() {
    return {
      zhCN
    }
  },
}
</script>

<style>
@font-face {
  font-family: 'AlibabaPuHuiTi';
  src: url('@/assets/fonts/AlibabaPuHuiTi-3-35-Thin.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}
html{
  scroll-behavior: smooth; /* 启用平滑滚动 */
  
}
html,
body {
  margin: 0;
  height: 100%;
  
}
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #2b2b2b;

  --primary-color: #1677ff;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1200px){
  #app {
    width: 1200px;
    overflow-y: auto;
    margin: 0 auto; 
  }
}

.colorText0 {
  background: linear-gradient(to right,
      #3ea9b7,
      #F1C72B,
      #0091ff,
      #3ea9b7);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: background-pan 3s linear infinite;
  background-size: 200%;
}

img {
  max-width: 100%;
  height: auto;
}
</style>